<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>{{ tituloedicion }}</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	
     
		<div class="content-boxed">

  			<div class="content bottom-0">
				
               <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">

								<span id="verificarrut_RUTCLIENTE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold"></span>
								<span id="r_RUTCLIENTE" name="r_RUTCLIENTE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Rut requerido</span>
								<input id="field_ST_RUT_CLIENTE" name="field_ST_RUT_CLIENTE" type="hidden" v-model="TABLE.ST_RUT_CLIENTE">
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Rut cliente:<span>(requerido)</span></label>
									<input id="RUTCLIENTE" name="RUTCLIENTE" type="text" maxlength="13"
									v-model="TABLE.ST_RUT_CLIENTE" 
									class="round-small" @blur="blurRut('RUTCLIENTE')" @change="Verificarrut()">
								</div>

								<span id="r_field_ST_NOMBRE_CLIENTE" name="r_field_ST_NOMBRE_CLIENTE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Nombre requerido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Nombre :<span>(requerido)</span></label>
									<input id="field_ST_NOMBRE_CLIENTE" name="field_ST_NOMBRE_CLIENTE" type="text" maxlength="20"
									v-model="TABLE.ST_NOMBRE_CLIENTE" 
									class="round-small">
								</div>

								<span id="r_field_ST_APEPAT_CLIENTE" name="r_field_ST_APEPAT_CLIENTE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Paterno requerido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Paterno :<span>(requerido)</span></label>
									<input id="field_ST_APEPAT_CLIENTE" name="field_ST_APEPAT_CLIENTE" type="text" maxlength="20"
									v-model="TABLE.ST_APEPAT_CLIENTE" 
									class="round-small">
								</div>

								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Materno :</label>
									<input id="field_ST_APEMAT_CLIENTE" name="field_ST_APEMAT_CLIENTE" type="text" maxlength="20"
									v-model="TABLE.ST_APEMAT_CLIENTE" 
									class="round-small">
								</div>

								<span id="r_field_ST_EMAIL_CLIENTE" name="r_field_ST_EMAIL_CLIENTE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">E-mail requerido</span>
								<span id="e_field_ST_EMAIL_CLIENTE" name="e_field_ST_EMAIL_CLIENTE" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">E-Mail inválido</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">E-mail :<span>(requerido)</span></label>
									<input id="field_ST_EMAIL_CLIENTE" name="field_ST_EMAIL_CLIENTE" type="text" maxlength="50"
									v-model="TABLE.ST_EMAIL_CLIENTE" 
									class="round-small">
								</div>
<br>
								<span id="r_fono1suf" name="r_fono1suf" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Móvil requerido</span>
								<span id="i_fono1suf" name="i_fono1suf" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Móvil debe ser un número</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Móvil :<span>(requerido)</span></label>									
									<table cellpadding="0" cellspacing="0"><tr><td><input ref="fono1pref" disabled class="round-small" value='569' maxlength=2 size=2></td><td>-</td>
									<td><input placeholder='Móvil' id="fono1suf" ref="fono1suf" @change="changefono1()" class="round-small" maxlength=8 size=10></td>
									</tr></table>
									<input type="hidden" v-model="TABLE.ST_FONO1_CLIENTE" name='field_ST_FONO1_CLIENTE' id='field_ST_FONO1_CLIENTE'>									
								</div>

								<span id="r_fono2suf" name="r_fono2suf" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Fono contacto requerido</span>
								<span id="i_fono2suf" name="i_fono2suf" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Fono contacto debe ser un número</span>
								<div class="form-field form-name" style="text-align:left">
									<label class="color-theme">Fono contacto :<span>(requerido)</span></label>									
									<table cellpadding="0" cellspacing="0"><tr><td><input ref="fono2pref" disabled class="round-small" value='562' maxlength=2 size=2></td><td>-</td>
									<td><input placeholder='Fono contacto' id="fono2suf" ref="fono2suf" @change="changefono2()" class="round-small" maxlength=8 size=10></td>
									</tr></table>
									<input type="hidden" v-model="TABLE.ST_FONO2_CLIENTE" name='field_ST_FONO2_CLIENTE' id='field_ST_FONO2_CLIENTE'>									
								</div>
					<div > 

						<div class="content-boxed">
								<a v-if="!isedit" href="#" class="button bg-blue1-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="GoAction('insertar');" data-formId="dataForm">Ingresar cliente</a>
								<a v-if="isedit" href="#" class="button bg-blue1-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="GoAction('actualizar');" data-formId="dataForm">Actualizar cliente</a>
						</div>
					</div>

                    </form>			
                </div>
            </div>


    	</div>
		
    </div>


</template>

<script>

import * as db from "../../database.js";
import * as validate from "../../validate.js";

export default {
	data() {
      return {
		TABLE:{},
		codvehiculo:0,
		tituloedicion:"Editar cliente",
		isedit:true,

		verificarrut:[],
		
		}
	},
	mounted() {
		let strSql;

		if(localStorage.getItem('editcodcliente')!="")
			{
			this.codcliente=localStorage.getItem('editcodcliente');
			this.isedit=true;
			localStorage.setItem('searchcliente',"");
			//localStorage.setItem('editcodvehiculo',"");

			this.tituloedicion="Editar cliente ficha N° "+this.codcliente;

			strSql="SELECT C.*,"
				+"'' fono1clientepref,'' fono1clientesuf"
				+" FROM T_CLI_CLIENTE C"
				+" WHERE IN_COD_CLIENTE="+this.codcliente

			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				
				this.TABLE=result.data.data

				if(this.TABLE.ST_FONO1_CLIENTE.length>3)
					{
					this.$refs.fono1pref.value="569";
					this.$refs.fono1suf.value=this.TABLE.ST_FONO1_CLIENTE.substring(3);
					}
				if(this.TABLE.ST_FONO2_CLIENTE.length>3)
					{
					this.$refs.fono2pref.value="562";
					this.$refs.fono2suf.value=this.TABLE.ST_FONO2_CLIENTE.substring(3);
					}

			}}); 


			}
		else
			{
			this.isedit=false;

			//IN_TIPO_CLIENTE=2->CLIENTEPNATURAL
			strSql =  " INSERT INTO T_CLI_CLIENTE(IN_TIPO_CLIENTE) VALUES(2)" 
					+ " SELECT MAX(IN_COD_CLIENTE) codcliente FROM T_CLI_CLIENTE" 
			db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				this.insertarcliente=result.data.data
				this.codcliente=this.insertarcliente.codcliente;
				this.tituloedicion="Nuevo cliente"+this.codcliente;
			}}); 

			localStorage.setItem('editcodcliente',"");
			}


	

		},

	methods: {
		GoAction(action)
			{
			if(this.TABLE.ST_RUT_CLIENTE!="")
				this.TABLE.ST_RUT_CLIENTE=this.TABLE.ST_RUT_CLIENTE.replaceAll('.','').replaceAll('-','');

			var strErr=validate.check(Formsubmit)
				if (strErr==""){

					this.params='{"valkey":"'+this.codcliente+'","tablename":"T_CLI_CLIENTE"}';
					db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
						if(action=="actualizar")
							{
							localStorage.setItem('searchcliente',"");
							window.location="/Wizardot1show";
							}
						else if(action=="insertar")
							{
							localStorage.setItem('searchcliente',this.TABLE.ST_RUT_CLIENTE);
							window.location="/NewOT";
							}
					}});
				}
			},

		changefono1(){this.TABLE.ST_FONO1_CLIENTE=this.$refs.fono1pref.value+''+this.$refs.fono1suf.value;this.$forceUpdate();},
		changefono2(){this.TABLE.ST_FONO2_CLIENTE=this.$refs.fono2pref.value+''+this.$refs.fono2suf.value;this.$forceUpdate();},

		//-------------------------------------------------------------------------------------------------------------------------------	
		Verificarrut(){

			let strSql;
			if(this.TABLE.ST_RUT_CLIENTE!="")
				{
				//this.TABLE.ST_RUT_CLIENTE=this.TABLE.ST_RUT_CLIENTE.replace(/./g, '');
				this.TABLE.ST_RUT_CLIENTE=this.TABLE.ST_RUT_CLIENTE.replaceAll('.','').replaceAll('-','');

				//this.TABLE.ST_RUT_CLIENTE=this.TABLE.ST_RUT_CLIENTE.replaceAll(/-/g, '');

				strSql="SELECT IN_COD_CLIENTE codficha,"
					+"ISNULL((SELECT IN_COD_CLIENTE"
					+" FROM T_CLI_CLIENTE C"
					+" WHERE IN_COD_CLIENTE<>"+this.codcliente
					+" AND ST_RUT_CLIENTE='"+this.TABLE.ST_RUT_CLIENTE+"'),0) codfichaverificada"
					+" FROM T_CLI_CLIENTE C"
					+" WHERE IN_COD_CLIENTE="+this.codcliente

				db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
					this.verificarrut=result.data.data;
					if(this.verificarrut.codfichaverificada>0)
						{
						this.TABLE.ST_RUT_CLIENTE="";
						if(document.getElementById('verificarrut_RUTCLIENTE').style.display=="none")
							{
							document.getElementById('verificarrut_RUTCLIENTE').innerHTML="Rut se encuentra en otro cliente";
							document.getElementById('verificarrut_RUTCLIENTE').style.display="";
							}
						}
					else if(document.getElementById('verificarrut_RUTCLIENTE').style.display=="")
						document.getElementById('verificarrut_RUTCLIENTE').style.display=="none";

					}}); 

				}

		},


		blurRut(fieldname){
			var objRut;
			var objMessage;
			var intTipo=0;
			var strValue;

			objRut=document.getElementById(fieldname);
			objMessage=document.getElementById('verificarrut_'+fieldname);
			if(!this.ValidaRut(objRut,objMessage))
				objRut.value='';

			if (objRut.value != '')
				{
				strValue=this.Limpiarut(objRut.value);
				objRut.value=strValue.toUpperCase();

				var strDV = strValue.substring(strValue.length-1,strValue.length);
				var strRut = strValue.substring(0,strValue.length-1);

				if (intTipo!=2)
				{
				if (intTipo==1 && strRut<50000000)
					{
					objRut.value='';
					strRut='';
					//alert('Rut no valido para persona juridica');
					objMessage.innerHTML="Rut no valido";
					objMessage.style.display="";
					return;
					}
				
				if (intTipo==0 && strRut>50000000)
					{
					objRut.value='';
					strRut='';
					//alert('Rut no valido para persona natural');
					objMessage.innerHTML="Rut no valido";
					objMessage.style.display="";
					return;
					}
				}
				
				var i=strRut.length;
				var strValueret='';
				while (i>0)
					{
					strValueret=strRut.substring(i-3,i)+'.'+strValueret;
					i=i-3;
					}
				strValueret=strValueret.substring(0,strValueret.length-1)+'-'+strDV;
				strValueret=strValueret.toUpperCase();
				objRut.value =strValueret;
				}

		objMessage=document.getElementById('verificarrut_'+fieldname).style.display="none";
	  	},

		digitoVerificador(strRut) {

			var Largo, LargoN, i, Total;
			var Numero="", Verif, Carac, CaracVal;
			var tmpRut,intTmp;

			tmpRut = strRut
			Largo = tmpRut.length
			LargoN = 0
			for(i=0;i<Largo;i++) {
				Carac = parseInt(tmpRut.charAt(i),10);
				if(Carac >=0 && Carac <=9) {
					Numero+=tmpRut.charAt(i);
					LargoN++;
				}
			}

			Total=0;
			for(i=LargoN-1;i>=0;i--) {
				if((LargoN - i) < 7) {
				intTmp=LargoN - i + 1;
				} else {
				intTmp=LargoN - i - 5;
				}
				Total+= parseInt(Numero.charAt(i),10) * intTmp 
			}
		
			CaracVal = 11 - (Total % 11)
			
			if(CaracVal==10) {
			return('K');
			}
			
			if(CaracVal >=0 && CaracVal <=9) {
			return(CaracVal);
			}
			
			if(CaracVal==11) {
			return(0);
			}
		},

	  	esRutValido(strRut,strDigito) {
			var digVerif;
			digVerif = this.digitoVerificador(strRut)

			return(digVerif == strDigito || (strDigito=="k" && digVerif=="K"))
			},

	 	ValidaRut(objRut,objMessage)
			{
			var strDV;
			var strRut;
			if(objRut.value.length>1)
				{
				strDV=objRut.value.substr(objRut.value.length-1,1)
				strRut=objRut.value.substr(0,objRut.value.length-1)

				if(this.esRutValido(strRut,strDV)==true)
					return true
				else
					{
					objMessage.innerHTML="Rut incorrecto";
					objMessage.style.display="";							
					}
				}
			else if(objField.value.length==1)
					{
					objMessage.innerHTML="Rut incorrecto";
					objMessage.style.display="";							
					}
			else
				return true
			},

		Limpiarut(strValue)
			{
			var i;
			var strValueret;

			strValueret='';
			i=strValue.length;
			while (i>0)
				{
				if (strValue.substring(i-1,i)!='.' && strValue.substring(i-1,i)!='-')
					strValueret=strValue.substring(i-1,i)+strValueret;
				i-=1;
				}

			return strValueret;
			}
		}

}

</script>